import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalstorageService } from 'src/app/global/localstorage.service';
import { Result } from 'src/app/shared/result';
import { environment } from 'src/environments/environment';
import { CommonModel } from 'src/app/shared/common-model';
import { pageload } from 'src/app/shared/pageload-model';

// import { GetUserDataComponent } from '../../shared/layout/get-user-data/get-user-data.component';

@Injectable({
  providedIn: 'root'
})
export class BusService {
  getLan: string;
  data: any;
  public Token: string;
  obj = new CommonModel;
  timeobj = new pageload;


  constructor(private http: HttpClient) {
    var token = LocalstorageService.getLocal('Token');

    this.obj.lan = LocalstorageService.getLanguage("language");
    this.getLan = LocalstorageService.getLanguage('language');
    this.data = JSON.parse(localStorage.getItem('currentUser'));
    this.Token = LocalstorageService.getLocal('Token');
    this.timeobj.pageid = 3;
    this.timeobj.pagename = 'Bus Services';
     this.timeobj.loadingtime = Number( LocalstorageService.getPageLoadTime("busservices"));     if(token != null && token != "" && token!= undefined && !LocalstorageService.TokenExpired(token)){
    this.timeobj.Token = LocalstorageService.getLocal('Token');
     }

    // alert(this.Token);
    // //console.log(this.Token)
    if(this.data != null)
      this.Token = this.data.token;
  }

  public InitHeader() {
    let headers;
    if(this.Token) {
      headers = { 'Authorization': 'Bearer ' + this.Token,
      'Content-Type': 'application/json'  };
    }
    return headers;
  }

  public GetAllRoutes() {
    let headers;
    headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/ListofRoutes/GetRoutes`, this.obj, { headers });
  }

  public GetAllStationsOnRoute(routeid,check) {
    // let headers;
    // headers = this.InitHeader();
    return this.http.get<Result>(`${environment.apiUrl}/SearchByLocation/GetStationOnRoute?routeid=` + routeid + `&lan=` + this.getLan + `&check=` + check);
    //return this.http.post<Result>(`${environment.apiUrl}/SearchByLocation/GetStationOnRoute`,this.getLan, d);
  }


  public GetFareConcessionData() {
    // let headers;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/GetStatisticsData/GetFareConcessionsData`, this.obj);
  }
  public pageLoadTimeInsert() {
    // let headers;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/GetStatisticsData/InsertPageLoaedTimeData`, this.timeobj);
  }
}
